<template>
  <div class="difference-wrapper">
    <div>
      {{ $t("aiPredictionReport.differenceFromYourActualAge") }}
    </div>
    <triangle :value="differenceFromRealAge"/>

    <display-value :value="differenceFromRealAge | valueOfAbs"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";

import Triangle from "../../atoms/Triangle";
import DisplayValue from "../../atoms/displayValue/DisplayValue"

export default {
  props: {
    healthAge: VueTypes.number.isRequired,
    realAge: VueTypes.number.isRequired,
  },
  components: {
    Triangle,
    DisplayValue
  },
  computed: {
    differenceFromRealAge() {
      return Math.floor(this.healthAge) - this.realAge
    }
  },
  filters: {
    valueOfAbs: function(value) {
      return Math.abs(value)
    }
  }
};
</script>

<style scoped>
.difference-wrapper {
  display: flex;
  justify-content: center;
  font-weight: bold;
}
</style>
